import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import jspPlatformApi from "client/portals";
import { MenuUpdateDeepInBatch } from "client/jspPlatformExperiment";
import {
  isApiError,
  isErrorResponseBodyType,
  toJspApiError,
} from "models/utils/apiUtils";

interface MenuBatchOperationState {
  isSaving: boolean;
  error: string | null | undefined;
}

const initialState: MenuBatchOperationState = {
  isSaving: false,
  error: null,
};

/** Batch update menus */
const batchUpdateMenus = createAsyncThunk(
  "menuBatchOperation/batchUpdateMenus",
  async (menus: MenuUpdateDeepInBatch[], { rejectWithValue }) =>
    jspPlatformApi()
      .menu.patchMenuMealBatch({
        body: menus,
      })
      .then((res) => res.data ?? [])
      .catch((error) => {
        let errMsg: string;
        const err = isApiError(error) ? toJspApiError(error) : null;
        if (err && isErrorResponseBodyType(err.body)) {
          errMsg = err.body.detail;
        } else {
          errMsg = "Unknown error!";
        }
        return rejectWithValue(errMsg);
      }),
);

export const menuBatchOperationSlice = createSlice({
  name: "menuBatchOperation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(batchUpdateMenus.pending, (state) => {
      return { ...state, isSaving: true, error: null };
    });
    builder.addCase(batchUpdateMenus.fulfilled, (state) => {
      return {
        ...state,
        isSaving: false,
      };
    });
    builder.addCase(batchUpdateMenus.rejected, (state, action) => {
      return {
        ...state,
        isSaving: false,
        error: action.payload as string,
      };
    });
  },
});

export const menuBatchOperationActions = {
  batchUpdateMenus,
};

const menuBatchOperationReducer = menuBatchOperationSlice.reducer;

export default menuBatchOperationReducer;
